module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "list-icon",
    on: {
      "click": _vm.showMark
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "login"
  }, [(!_vm.isLogin) ? _c('div', {
    on: {
      "click": _vm.loginHandle
    }
  }, [_c('span', [_vm._v("登录")]), _vm._v("|"), _c('span', [_vm._v("注册")])]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "login-icon",
    on: {
      "click": _vm.checkHandle
    }
  }, [_c('i')]) : _vm._e(), _vm._v(" "), (_vm.isLoginContainer) ? _c('div', {
    staticClass: "login-container"
  }, [_c('ul', [_c('li', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出登录")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.changeUser
    }
  }, [_vm._v("切换账号")])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23e1f63b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerMobile/index.vue
// module id = 345
// module chunks = 1